import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import MerchantCategoryRuleModal from './Modals/MerchantCategoryRuleModal'
import CommonRuleActionsCell from './../Common/CommonRuleActionsCell'

import { MerchantCategoryRulesActions } from './../actions'

class MerchantCategoryActionsCell extends Component {
  deleteFunction = id => {
    this.props.saveRuleAction({ id, isActive: false })
  }

  activateFunction = id => {
    this.props.saveRuleAction({ id, isActive: true })
  }

  getEditModal = () => {
    const { id, merchantId, merchantName, categoryId, categoryFullPath } = this.props.row
    const { saveRuleAction } = this.props
    return (
      <MerchantCategoryRuleModal
        value={{
          id,
          categoryId,
          categoryFullPath,
          merchantId,
          merchantName
        }}
        onOkHandler={saveRuleAction}
      />
    )
  }

  render() {
    const { id, isActive, merchantIsActive, categoryIsActive, ruleIsActive } = this.props.row
    let activationTooltip = ''
    let isActivationBlocked = false

    if (isActive) {
      activationTooltip = 'Delete rule'
    } else if (!merchantIsActive) {
      activationTooltip = "Can't reactivate because related Merchant is inactivate"
      isActivationBlocked = true
    } else if (!categoryIsActive) {
      activationTooltip = "Can't reactivate because related Category is inactivate"
      isActivationBlocked = true
    } else if (!ruleIsActive && merchantIsActive && categoryIsActive) {
      activationTooltip = 'Re-Activate'
    }

    return (
      <CommonRuleActionsCell
        editModaTitle="Edit Merchant Category Rule (MCR)"
        editModalContent={this.getEditModal()}
        id={id}
        isActive={isActive}
        isActivationBlocked={isActivationBlocked}
        activationTooltip={activationTooltip}
        deleteFunction={this.deleteFunction}
        activateFunction={this.activateFunction}
      />
    )
  }
}

MerchantCategoryActionsCell.propTypes = {
  saveRuleAction: PropTypes.func.isRequired,
  row: PropTypes.object.isRequired
}

const mapDispatchToProps = {
  saveRuleAction: MerchantCategoryRulesActions.save
}

export default connect(null, mapDispatchToProps)(MerchantCategoryActionsCell)
